import React from "react";
import "../App.css";
import { Row, Col, Divider, Layout, Layout as AntdLayout } from "antd";
import "antd/dist/antd.css";
import styled from "@emotion/styled";
import Footer from "../components/Footer";
import HeaderEn from "../components/HeaderEn";

const CustomContent = styled(AntdLayout.Content)({
  backgroundColor: "lightyellow",
  color: "lightblack",
  textAlign: "left",
  paddingLeft: "5%",
  paddingRight: "5%",
  paddingTop: "3%",
  "@media (max-width: 992px)": {
    paddingTop: "5%",
  },
  "@media (max-width: 768px)": {
    paddingTop: "6%",
  },
  "@media (max-width: 576px)": {
    paddingTop: "6%",
  },
  "@media (max-width: 480px)": {
    paddingTop: "8%",
  },
});
const Maintext = styled(AntdLayout.Content)({
  backgroundColor: "transparent",
  fontColor: "lightblack",
  textAlign: "left",
  "@media (max-width: 992px)": {
    paddingLeft: "6%",
  },
  "@media (max-width: 768px)": {
    paddingLeft: "7%",
  },
  "@media (max-width: 576px)": {
    paddingLeft: "8%",
  },
  "@media (max-width: 480px)": {
    paddingLeft: "8%",
  },
});

const Contact_en: React.FC = (): JSX.Element => (
  <Layout>
    <HeaderEn />
    <CustomContent>
      <Row>
        <Col xs={24} sm={24} md={24} lg={24} xl={24}>
          <Maintext style={{ fontSize: "26px", fontWeight: "bold" }}>
            Contact
          </Maintext>
          <br />
          <Maintext>
            <p style={{ fontWeight: "bold" }}>Kika Holland BV</p>
            <p>Milovan Milošević</p>
            <p>Wegedoorn 20</p>
            <p>5432EA Cuijk</p>
            <p>The Netherlands</p>
            <p>KvK number: 17210762</p>
            <p>BTW number: NL 819853689</p>
          </Maintext>
          <Divider />
          <Maintext>
            <p style={{ fontWeight: "bold" }}>Contact Us:</p>
            <p> E-mail:</p>
            <p>
              1.){" "}
              <a
                style={{ color: "darkgreen" }}
                href="mailto:info@kikaholland.com"
              >
                info@kikaholland.com
              </a>
            </p>
            <p>
              2.){" "}
              <a
                style={{ color: "darkgreen" }}
                href="mailto:kikaholland@gmail.com"
              >
                kikaholland@gmail.com
              </a>
            </p>
            <p> Tel-Fax: +31(0)485313810 </p>
            <p>Mobile: +31(0)650435140</p>
            <p>Skype: filip.milosevic641</p>
          </Maintext>
          <Divider />
          <Maintext>
            <p style={{ fontWeight: "bold" }}> Bank Details:</p>
            <p>ING N.V, Amsterdam</p>
            <p>IBAN NL32 INGB 0006 8980 84</p>
            <p>BIC (Swift) INGBNL2A</p>
          </Maintext>
          <Divider />
          <Maintext>
            <p style={{ fontWeight: "bold" }}>
            Contact Person in Montenegro Office:
            </p>
            <p>Lazar Lalević</p>
            <p>Tel: +38267226472</p>
          </Maintext>
          <Divider />
          <Maintext>
            <p style={{ fontWeight: "bold" }}>
              Contact Person in the Netherlands Office:
            </p>
            <p>Filip Milošević</p>
            <p>Tel: +31(0)623153979</p>
            <p>
              {" "}
              E-mail:{" "}
              <a
                style={{ color: "darkgreen" }}
                href="mailto:filipkika@gmail.com"
              >
                filipkika@gmail.com
              </a>
            </p>
            <br />
          </Maintext>
        </Col>
      </Row>
    </CustomContent>
    <Footer />
  </Layout>
);

export default Contact_en;
